import * as zod from 'zod'

export const locationEditSchema = zod.object({
  hidden: zod.boolean(),
})

export type LocationEditSchema = zod.infer<typeof locationEditSchema>
